/*
 * (c) Copyright 2021 Thalia Bücher GmbH
 *
 * Created on 04.03.2021
 *
 * This file contains unpublished, proprietary trade secret information of
 * Thalia Bücher GmbH. Use, transcription, duplication and
 * modification are strictly prohibited without prior written consent of
 * Thalia Bücher GmbH.
 */

// Fehlerticket: WDD-1315
// Die ursprüngliche Variante mit einem CustomElement funktioniert nicht wie erwartet.
// Taucht das erste <script-consent> im <head> auf, bricht der Browser die Verarbeitung des <head> ab 
// und verschiebt alles was folgt in den <body>, z.B. <title> oder <meta> Tags.
// Folgen dieses Verhaltens sind z.B. SEO-Probleme.
// HINWEIS:
// Solange noch <script-consent> auf der Seite existieren, darf der folgende import nicht entfernt werden.
import './src/legacy.js';

// Fehlerticket: WDD-1315
// Für die neuen Variante ist das CustomElement durch <script type="script-consent"> ersetzt.
// Durch den [type] verhindern wir zum einen die Ausführung des Scripts. 
// Zum anderen bricht der Browser seine normale Verarbeitung im <head> nicht ab, 
// sondern überspringt bzw. ignoriert das <script> Tag mit dem für ihn unbekannten [type].
const COOKIE_NAME = 'COOKIECONSENT';
const COOKIE_VALUE = 1;

const scripte = document.querySelectorAll('script[type="script-consent"]');

if (typeof window.heimdallActive === 'undefined' || !window.heimdallActive) {
    console.log('Heimdall-Service ist nicht aktiv => scripte laden');
    scripte.forEach(scriptLaden);
} else {
    consentCookiePruefen(COOKIE_NAME, COOKIE_VALUE);
    initMutationObserver();
}

document.addEventListener('consent-click', consentBannerKlickVerarbeiten.bind(null, scripte));

function consentCookiePruefen(name, value) {
    if (consentCookieAkzeptiert(name, value)) {
        console.log('Cookies akzeptiert => scripte laden');
        scripte.forEach(scriptLaden);
    } else {
        console.log('Kein Cookie gesetzt || Nur funktionale Cookies akzeptiert => scripte nicht laden');
        return;
    }
}

function consentCookieAkzeptiert(name, value) {
    return document.cookie
        .split(';')
        .filter((item) => item
            .includes(`${name}=${value}`)).length ?
        true :
        false;
}

function scriptLaden(script) {
    const erstesScript = document.querySelector('script');
    const scriptElement = document.createElement('SCRIPT');
    scriptElement.async = true;
    if (script.src) {
        scriptElement.src = script.src;
    } else {
        scriptElement.innerHTML = script.innerText;
    }
    erstesScript.insertAdjacentElement('beforebegin', scriptElement);
    if (script.parentNode) script.parentNode.removeChild(script);
}

function consentBannerKlickVerarbeiten(scripte, event) {
    if (consentBannerOptIn(event)) {
        console.log('Cookies akzeptiert => scripte laden');
        scripte.forEach(scriptLaden);
    } else {
        console.log('Kein Cookie gesetzt || Nur funktionale Cookies akzeptiert => scripte nicht laden');
        return;
    }
}

function consentBannerOptIn(event) {
    return event.target.dataset.consent === 'agree';
}

function initMutationObserver() {
    const config = {
        attributes: true,
        childList: true,
        subtree: true
    };
    const observer = new MutationObserver(mutations => mutations.forEach(mutationPruefen));
    observer.observe(document.documentElement, config);
}

function mutationPruefen(mutation) {
    const neueKnoten = mutation.addedNodes;
    neueKnoten.forEach(mutationVerarbeiten);
}

function mutationVerarbeiten(knoten) {
    if (knoten.type === 'script-consent' && consentCookieAkzeptiert(COOKIE_NAME, COOKIE_VALUE)) {
        scriptLaden(knoten);
    } else if (knoten.type === 'script-consent') {
        console.log('Kein Cookie gesetzt || Nur funktionale Cookies akzeptiert => scripte nicht laden');
        return;
    }
}
